import { t } from "@/i18n-js/instance";
import { ModalManager } from "@/react/components/Layout/ModalManagerProvider";
import { EDITOR_SELECTION_MODAL_ID } from "@/react/components/SettingsApp/Emails/components/Builder/BuilderFields/EditorSelectionModal";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import { NavigationList } from "./NavigationList";

export const Sidebar = ({
  activeId,
  navigationItems,
  onClickNavItem,
  shouldEnableCreateButton,
}: {
  activeId: string;
  navigationItems: string[];
  onClickNavItem: (id: string) => void;
  shouldEnableCreateButton: boolean;
}) => {
  const showEditorSelectionModal = () => {
    void ModalManager.show(EDITOR_SELECTION_MODAL_ID);
  };

  return (
    <div
      className={classNames(
        "sticky top-24 ml-4 mr-6 flex w-full max-w-[272px] flex-col gap-5",
      )}
    >
      <Button
        variant="circle"
        large
        onClick={showEditorSelectionModal}
        className="mx-[10px] flex items-center justify-center gap-2 px-4 py-2"
        disabled={!shouldEnableCreateButton}
      >
        <span className="flex">
          <Icon type="20-plus-v2" size={20} />
        </span>
        <span>{t("settings.workflows.start_from_scratch")}</span>
      </Button>
      <div className="mx-[10px] flex flex-col gap-3.5">
        <NavigationList
          activeId={activeId}
          navigationItems={navigationItems}
          onClickNavItem={onClickNavItem}
        />
      </div>
    </div>
  );
};
